import { createSlice } from '@reduxjs/toolkit';
import { resetApplication } from '../application/slice';
import additionalPortRequestState from './state';
const additionalPortRequestSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => additionalPortRequestState);
    },
    initialState: additionalPortRequestState,
    name: 'additionalPortRequest',
    reducers: {
        errorReceiveAdditionalPortRequest: state => {
            state.requestingAdditionalPortRequest = false;
        },
        failedReceiveAdditionalPortRequest: state => {
            state.requestingAdditionalPortRequest = false;
        },
        receiveAdditionalPortRequest: state => {
            state.requestingAdditionalPortRequest = false;
        },
        requestAdditionalPortRequest: {
            prepare: (location, portCount) => {
                return {
                    payload: {
                        location,
                        portCount
                    }
                };
            },
            reducer: state => {
                state.requestingAdditionalPortRequest = true;
            }
        },
        resetAdditionalPortRequest: () => additionalPortRequestState
    }
});
export const { errorReceiveAdditionalPortRequest, failedReceiveAdditionalPortRequest, receiveAdditionalPortRequest, requestAdditionalPortRequest, resetAdditionalPortRequest } = additionalPortRequestSlice.actions;
export default additionalPortRequestSlice.reducer;
